export const DISCOUNT_TYPE = {
  PERCENTAGE: "percentage",
  FIXED_AMOUNT: "fixed_amount",
} as const;

export const DISCOUNT_DURATION = {
  ONCE: "once",
  REPEATING: "repeating",
  FOREVER: "forever",
} as const;
